
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/brands",
      function () {
        return require("private-next-pages/shop/brands/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/brands"])
      });
    }
  